import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const BasicInfoSection = ({ formData, errors, onChange }) => {
  const [slugAvailable, setSlugAvailable] = useState(null);
  const [checkingSlug, setCheckingSlug] = useState(false);

  const generateSlug = (name) => {
    return name?.toLowerCase()?.replace(/[^a-z0-9\s-]/g, '')?.replace(/\s+/g, '-')?.replace(/-+/g, '-')?.trim();
  };

  const checkSlugAvailability = (slug) => {
    if (!slug) {
      setSlugAvailable(null);
      return;
    }

    setCheckingSlug(true);
    setTimeout(() => {
      const existingSlugs = ['demo-epoxy', 'premium-floors', 'elite-coatings'];
      const isAvailable = !existingSlugs?.includes(slug);
      setSlugAvailable(isAvailable);
      setCheckingSlug(false);
    }, 500);
  };

  useEffect(() => {
    if (formData?.slug) {
      checkSlugAvailability(formData?.slug);
    }
  }, [formData?.slug]);

  const handleNameChange = (e) => {
    const name = e?.target?.value;
    onChange({ target: { name: 'name', value: name } });
    
    if (!formData?.isEditMode) {
      const suggestedSlug = generateSlug(name);
      onChange({ target: { name: 'slug', value: suggestedSlug } });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-text-primary">Basic Information</h2>
          <p className="text-sm text-text-secondary">Company name and unique identifier</p>
        </div>
      </div>
      <div className="space-y-4">
        <Input
          label="Company Name"
          type="text"
          name="name"
          value={formData?.name}
          onChange={handleNameChange}
          placeholder="Enter company name"
          required
          error={errors?.name}
          description="This will be displayed across the visualizer"
        />

        <div className="relative">
          <Input
            label="Unique Slug-ID"
            type="text"
            name="slug"
            value={formData?.slug}
            onChange={onChange}
            placeholder="company-slug-id"
            required
            error={errors?.slug}
            description="Used in URL: yourdomain.com/visualizer/[slug-id]"
            disabled={formData?.isEditMode}
          />
          {checkingSlug && (
            <div className="absolute right-3 top-9 flex items-center gap-2 text-sm text-text-secondary">
              <Icon name="Loader2" size={16} className="animate-spin" />
              <span>Checking...</span>
            </div>
          )}
          {!checkingSlug && slugAvailable !== null && formData?.slug && (
            <div className={`absolute right-3 top-9 flex items-center gap-2 text-sm ${slugAvailable ? 'text-success' : 'text-error'}`}>
              <Icon name={slugAvailable ? 'CheckCircle' : 'XCircle'} size={16} />
              <span>{slugAvailable ? 'Available' : 'Already taken'}</span>
            </div>
          )}
        </div>

        <Input
          label="Company Description"
          type="text"
          name="description"
          value={formData?.description}
          onChange={onChange}
          placeholder="Brief description of your epoxy flooring services"
          description="Optional: Displayed on company profile"
        />
      </div>
    </div>
  );
};

export default BasicInfoSection;